import { PropsWithChildren, ReactNode } from 'react';
import { Dialog as DialogComponent, DialogPanel, DialogTitle } from '@headlessui/react';
import { Icon } from '../Icon';

type DialogProps = PropsWithChildren<{
    isOpen: boolean;
    onClose: () => void;
    title?: string;
    hideHeader?: boolean;
    footer?: ReactNode;
}>

export const Dialog = ({ isOpen, onClose, title, hideHeader = false, children, footer }: DialogProps) => {
    return (
        <DialogComponent open={isOpen} onClose={onClose} className="relative z-50">
            <div className="fixed inset-0 w-screen overflow-y-auto bg-primary-container/60">
                <DialogPanel
                    className="mt-4 flex min-h-screen w-screen flex-col overflow-clip rounded-2xl bg-background shadow-lg md:mx-auto md:my-4 md:min-h-0 md:max-w-2xl">
                    {!hideHeader && (
                        <DialogTitle
                            className="sticky top-0 z-10 flex h-16 w-full flex-row items-center border-b border-outline/20 bg-background px-4">
                            {/*<h2 className="text-black grow text-lg font-semibold uppercase">*/}
                            {title ?? ''}
                            {/*</h2>*/}

                            <button
                                className="flex size-8 items-center justify-center rounded-full p-0 hover:bg-surface-2"
                                onClick={onClose}>
                                <Icon name={'close'} />
                            </button>
                        </DialogTitle>
                    )}

                    <div className="grow p-4">
                        {children}
                    </div>

                    {footer && (
                        <footer
                            className="sticky bottom-0 z-10 flex h-16 w-full flex-row items-center border-t border-outline/20 bg-background px-4">
                            {footer}
                        </footer>
                    )}
                </DialogPanel>
            </div>
        </DialogComponent>
    );
};
